export default __webpack_public_path__ + "static/media/PDFLogo.d3482e1c.png";